import { extendTheme, ThemeOverride, withDefaultColorScheme } from '@chakra-ui/react';

import colors from './colors';
import components from './components';
import styles from './styles';
import tokens from './tokens';

const base: ThemeOverride = {
  styles,
  components,
  colors,
  initialColorMode: 'dark',
  useSystemColorMode: false,
  semanticTokens: tokens,
};

const theme = extendTheme(
  base,
  withDefaultColorScheme({
    colorScheme: 'primary',
    components: ['Tab', 'Tabs', 'TabList'],
  }),
  withDefaultColorScheme({
    colorScheme: 'white',
    components: ['Input', 'Textarea'],
  })
);
export default theme;
